import { CustomFilterPillProps } from "../../../SharedComponents/Interfaces/CustomFilterPill.interfaces";
import { createFilterPill } from "../../CustomerSearch/CustomerSearch.common";

export const FILTER_PILL = {
  INITIAL_STATE: { menuItems: [], selectedMenuItems: [] },
  INITIAL_DATA: [
    createFilterPill("serviceFamilies", "Service Families", { Security: true }),
    createFilterPill("serviceNames", "Service Names"),
    createFilterPill("acrProductNames", "Product Names")
  ] as CustomFilterPillProps[]
};

export const FILTERABLE_REVENUE_FIELDS = ["serviceFamily", "serviceName", "acrProductName", "billingMonth"] as const;
export const MSSALES_REQUEST_LINK = "https://euaaccessportal.microsoft.com/request/access/MSSales";
export const PERMISSION_MESSAGE = "You don't have permission to view this page.";
export const NO_DATA_MESSAGE = "Revenue details are not available for this tenant.";